export interface IApiEndpointInfo {
    basePath: string;
    fullPath: string;
    appId: string;
    hash?: string;
}
